import React, { useEffect, useState } from 'react';
import Footer from '../Components/footer';
import oct from '../Images/News/octo.png';
import atlan from '../Images/News/atlan.png';
import merm from '../Images/News/merm.png';
import underwater from '../Images/News/underwater.png';
import { Link, useNavigate } from "react-router-dom";
import Logo from "../Images/Home/boat.png";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";

export default function News(props) {

    const [User, SetUser] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        onAuthStateChanged(props.auth, (user) => {
            if (user) {
                // User is signed in, see docs for a list of available properties
                // https://firebase.google.com/docs/reference/js/firebase.User
                SetUser(user);
                const uid = user.uid;
                // ...
                console.log("uid", uid)
            } else {
                // User is signed out
                // ...
                console.log("user is logged out")
            }
        });
    }, [])

    function signout() {
        signOut(props.auth).then(() => {
            window.location.reload(false);
            // Sign-out successful.
        }).catch((error) => {
            // An error happened.
        });
    }

    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-dark nav-bg fixed-top">
                <div className="container-fluid">
                    <Link to="/" className="navbar-brand"><img src={Logo} alt="Logo" width="30" height="30" /></Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0 navbar-nav-scroll">
                            <li className="nav-item">
                                <Link to="/" className="nav-link" aria-current="page">Home</Link>
                            </li>
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Boats
                                </a>
                                <ul className="dropdown-menu">
                                    <li><Link to="/cechoii" className="dropdown-item">C-ECHO II</Link></li>
                                    <li><Link to="/nimar" className="dropdown-item">Nimar</Link></li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <Link to="/routes" className="nav-link">Routes</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/news" className="nav-link active">News</Link>
                                </li>
                            {User !== '' ? <li className="nav-item">
                                <Link to="/contact" className="nav-link ">Book a boat</Link>
                            </li> : null}
                        </ul>
                        <ul className="navbar-nav navbar-nav-scroll">
                            {User !== '' ? <li className="nav-item">
                                <Link to="/bookings" className="nav-link">Bookings</Link>
                            </li> : null}
                            <li className="nav-item">
                                {User === '' ? <Link to="/login" className="nav-link">Login</Link> : null}
                            </li>
                            <li className="nav-item">
                                {User === '' ? <Link to="/signup" className="nav-link">Register</Link> : null}
                            </li>
                            <li>
                                {User !== '' ? <Link to="/" className="nav-link" onClick={signout}>Logout</Link> : null}
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <section>
                <div class="coverBigNews"></div>
            </section>
            <section>
                <div className="container pt-4">
                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <h1 className="fw-bolder fs-1z text-black">Fake News</h1>
                            <small><i>"that do not make sense at all"</i></small>
                        </div>
                    </div>
                </div>
            </section>
            <section style={{ padding: '50px' }} className="d-flex flex-column align-items-center">
                <div className="card mb-3" style={{ maxWidth: '800px' }}>
                    <div className="row g-0">
                        <div className="col-md-4">
                            <img src={oct} className="img-fluid rounded-start" alt="Octopus playing chess" style={{ objectFit: 'cover', height: '100%', width: '100%' }} />
                        </div>
                        <div className="col-md-8">
                            <div className="card-body">
                                <h5 className="card-title">Local Octopus Wins Underwater Chess Championship</h5>
                                <p className="card-text"> In a shocking upset, a local octopus has won the annual underwater chess
                                    championship against a field of highly trained human competitors. The octopus, who had been
                                    secretly studying the game for years, used its eight arms to expertly move the chess pieces
                                    around the board. When asked for comment, the octopus said, "I've been waiting for this moment
                                    my entire life.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mb-3" style={{ maxWidth: '800px' }}>
                    <div className="row g-0">
                        <div className="col-md-4">
                            <img src={atlan} className="img-fluid rounded-start" alt="Octopus playing chess" style={{ objectFit: 'cover', height: '100%', width: '100%' }} />
                        </div>
                        <div className="col-md-8">
                            <div className="card-body">
                                <h5 className="card-title">Lost City of Atlantis Found...Turns Out It's Just a Really Nice Underwater Resort</h5>
                                <p className="card-text"> After years of searching, divers have finally discovered the fabled lost city of
                                    Atlantis...only to find out that it's just a really nice underwater resort. The resort, which features
                                    luxurious accommodations and top-notch amenities, has been secretly operating for years without anyone realizing that it was the legendary city of Atlantis.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mb-3" style={{ maxWidth: '800px' }}>
                    <div className="row g-0">
                        <div className="col-md-4">
                            <img src={merm} className="img-fluid rounded-start" alt="Octopus playing chess" style={{ objectFit: 'cover', height: '100%', width: '100%' }} />
                        </div>
                        <div className="col-md-8">
                            <div className="card-body">
                                <h5 className="card-title">Mermaid Convention Cancelled Due to Human Attendance</h5>
                                <p className="card-text"> The annual mermaid convention, which brings together mermaids from all over the
                                    world, has been cancelled due to the overwhelming number of humans attending. The mermaids, who were
                                    initially excited to show off their beautiful tails and sing underwater songs, became frustrated
                                    when they were constantly bombarded with requests for photos and autographs.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mb-3" style={{ maxWidth: '800px' }}>
                    <div className="row g-0">
                        <div className="col-md-4">
                            <img src={underwater} className="img-fluid rounded-start" alt="Octopus playing chess" style={{ objectFit: 'cover', height: '100%', width: '100%' }} />
                        </div>
                        <div className="col-md-8">
                            <div className="card-body">
                                <h5 className="card-title">Scuba Diver Wins Underwater Karaoke Contest with Impressive Rendition of 'Under the Sea</h5>
                                <p className="card-text"> In a stunning performance, a scuba diver has won the annual underwater karaoke
                                    contest with a flawless rendition of "Under the Sea" from The Little Mermaid. The diver, who had
                                    been practicing for months, stunned the judges with their pitch-perfect vocals and impressive
                                    breath control. When asked for comment, the diver said, "I've always loved that song...
                                    I guess you could say I was born to sing it underwater.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}